<script setup lang="ts">
import { computed } from "vue";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import zhTw from "element-plus/es/locale/lang/zh-tw";
import en from "element-plus/es/locale/lang/en";
import { getCurrentLocale } from "@/i18n";

// COCHE §10.1.10 — drive Element Plus's built-in i18n (empty-state text,
// pagination, date-picker, etc.) from the same selector that vue-i18n uses.
// LocaleSwitcher.setCurrentLocale() reloads the page, so a computed bound
// to getCurrentLocale() is enough — no live re-render needed.
const elLocale = computed(() => {
	const code = getCurrentLocale();
	if (code === "en_hk") return en;
	if (code === "zh_hk") return zhTw;
	return zhCn;
});
</script>

<template>
	<el-config-provider :locale="elLocale">
		<router-view></router-view>
	</el-config-provider>
</template>

<style scoped lang="scss"></style>
